import { render, staticRenderFns } from "./TableComponentsNew.vue?vue&type=template&id=41022af7&scoped=true&"
import script from "./TableComponentsNew.vue?vue&type=script&lang=js&"
export * from "./TableComponentsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41022af7",
  null
  
)

export default component.exports